/* ==========================================================
   Image Popup (Fancybox)
   Any link with href="#gallery-NAME" opens the hidden gallery
   with id="gallery-NAME" (see snippets/image-popup-gallery.liquid).
   Works on every page, including links added later.
   ========================================================== */
(function ($) {
  if (!$ || !$.fancybox) return;

  $(document).on("click", 'a[href^="#gallery-"]', function (e) {
    var $gallery = $($(this).attr("href"));
    if (!$gallery.length) return;

    e.preventDefault();

    var items = [];
    $gallery.find("a[href]").each(function () {
      items.push({
        src: this.getAttribute("href"),
        type: "image",
        caption: this.getAttribute("data-caption") || ""
      });
    });

    $.fancybox.open(items, { loop: true }, 0);
  });
})(window.jQuery);
